import type { FC } from "react";
import { AVATAR_PART } from "../../assistantAvatarMotion";

interface AvatarWaveHandProps {
	cx: number;
	cy: number;
	rx: number;
	ry: number;
	fill: string;
	outline: string;
}

/** The raised hand shown while Annie needs you; the needs-you motion waves it once. */
export const AvatarWaveHand: FC<AvatarWaveHandProps> = ({ cx, cy, rx, ry, fill, outline }) => (
	<g className={AVATAR_PART.WAVE}>
		<ellipse cx={cx} cy={cy} rx={rx} ry={ry} fill={fill} stroke={outline} />
	</g>
);
